import React, { useState, useEffect } from 'react';
import FilterPill from '../FilterPill/FilterPill';
import './FoilSelector.css';

interface FoilSelectorProps {
  onChange?: (activeFilters: string[]) => void;
  initialFoil?: boolean;
  initialRegular?: boolean;
}

const FoilSelector: React.FC<FoilSelectorProps> = ({ 
  onChange,
  initialFoil = true,
  initialRegular = true
}) => {
  const [active, setActive] = useState({ 
    Foil: initialFoil, 
    Regular: initialRegular 
  });
  
  // Update state when props change (for edit mode)
  useEffect(() => {
    setActive({ 
      Foil: initialFoil, 
      Regular: initialRegular 
    });
  }, [initialFoil, initialRegular]);

  const toggle = (key: 'Foil' | 'Regular') => {
    const updated = { ...active, [key]: !active[key] };
    setActive(updated);
    onChange?.(Object.keys(updated).filter((k) => updated[k as keyof typeof updated]));
  };

return (
  <div className="foil-selector">
    <label>Foil:</label>
    <div className="foil-selector-buttons">
      <FilterPill label="Foil" active={active.Foil} onToggle={() => toggle('Foil')} />
      <FilterPill label="Regular" active={active.Regular} onToggle={() => toggle('Regular')} />
    </div>
  </div>
);
};

export default FoilSelector;
